import { useQuery } from '@tanstack/react-query';
import { MoonStar } from 'lucide-react';
import { get } from '../lib/api';

/** "Fora do horário" no topo: o cliente recebe a resposta automática e as ligações vão para o aviso. */
export function BusinessHoursBadge() {
  const status = useQuery({
    queryKey: ['business-hours', 'status'],
    queryFn: () => get<{ open: boolean; alwaysOpen: boolean; nextOpening: string | null }>('/business-hours/status'),
    refetchInterval: 60_000,
  }).data;
  if (!status || status.open) return null;
  return (
    <span
      className="flex items-center gap-1 rounded-md bg-warn/15 px-2 py-0.5 text-xs font-medium text-warn"
      title={`Fora do horário de atendimento: o WhatsApp responde automaticamente e as ligações vão para o aviso. Abre ${status.nextOpening ?? 'assim que possível'}.`}
    >
      <MoonStar className="size-3.5" /> fora do horário
    </span>
  );
}
